import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ApiService } from '../api.service';
import { ApiResponse } from '../api-response-models';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class DocumentService {

    constructor(
        private apiService: ApiService) {

    }

    getDownloadUrlFor(documentId: number): string{
        console.log(">>document service>getDownloadUrlFor", documentId);
        return this.apiService.getDownloadUrlFor(documentId);
    }

    uploadDocument(file: File): Observable<HttpEvent<any>> {
        console.log(">>document service>postDocument");
        return this.apiService.uploadFile('documents', file);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/document.service.ts